export default {"src":"/_next/static/media/Juventus.e9e60c6a.svg","height":86,"width":54,"blurWidth":0,"blurHeight":0};